import { render, staticRenderFns } from "./TalentDevDetails.vue?vue&type=template&id=51ff260e&"
import script from "./TalentDevDetails.vue?vue&type=script&lang=js&"
export * from "./TalentDevDetails.vue?vue&type=script&lang=js&"
import style0 from "./TalentDevDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports